import React from 'react';
import Modal from '../common/Modal.jsx';
import FormularioRegistroLubricantes from './FormularioRegistroLubricantes.jsx';

const ModalRegistroLubricante = ({ isOpen, onClose, onSaved, registro = null, initialEquipo = null, initialMecanico = null, hideFkCreateButtons = false }) => {
  const handleSave = async (savedData, opts = {}) => {
    if (typeof onSaved === 'function') {
      await onSaved();
    }
    if (opts.keepOpen) return; // "Guardar y nuevo/duplicar": el modal se queda abierto
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleCancel = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title={registro ? 'Editar Registro de Lubricante' : 'Nuevo Registro de Lubricante'}
      size="lg"
    >
      <FormularioRegistroLubricantes
        registro={registro || undefined}
        initialEquipo={registro ? undefined : initialEquipo}
        initialMecanico={registro ? undefined : initialMecanico}
        onSave={handleSave}
        onCancel={handleCancel}
        showTitle={false}
        hideFkCreateButtons={hideFkCreateButtons}
        enableSaveAndNew={!registro}
      />
    </Modal>
  );
};

export default ModalRegistroLubricante;
